import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TranslocoModule } from '@jsverse/transloco';
import { ProgrammeListPromoComponent } from './programme-list-promo.component';
import { LoaderGlobeAnimationDetailComponent } from '../../loaders';
import { RatingModule } from 'ngx-bootstrap/rating';
import { FormsModule } from '@angular/forms';
import { PaginationModule, ImageUrlPipe, ImageForRolePipe } from '@frontend/shared';

@NgModule({
  declarations: [
    ProgrammeListPromoComponent,
  ],
  exports: [
    ProgrammeListPromoComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule,
    LoaderGlobeAnimationDetailComponent,
    FormsModule,
    RatingModule,
    PaginationModule,
    ImageUrlPipe,
    ImageForRolePipe,
  ],
})
export class ProgrammeListModule { }
